import { Component, Input } from '@angular/core';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'al-badges',
    template: `
    <span class="al-badge-{{size}} al-badge-{{type}}">
    <ng-content></ng-content>
</span>
    `
})
export class AlBadgesComponent {
    // Type of badges like Action , Tip.
    @Input() type: string = 'action';

    // Size of badges like Action Large, Action small, Tip Large, Tip Small.
    @Input() size: string = 'small';

}
